import styled from 'styled-components';

import InsetContainer from '@ad-scripts/presentation/components/common/containers/inset_container';

const StyledFooter = styled(InsetContainer).attrs({ inset: 'medium' })`
  align-items: flex-end;
  align-self: flex-end;
  background-color: ${p => p.theme.colors.white};
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: flex-end;
  width: 100%;
  position: sticky;
  bottom: 0;
`;

const FooterLarge = styled(StyledFooter).attrs({ inset: 'large' })`
  background-color: transparent;
`;

export { FooterLarge };
export default StyledFooter;
